import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';
import ChatInput from './ChatInput';
import SingularLogo from '../../resources/svg/singular_logo_blue_figma.svg';
import css from './ChatEmptyState.css';

const SUGGESTIONS = [
    {
        query: 'Why there is a daily decrease in my Installs in the last week?',
        icon: 'chart-bar',
        iconColor: 'var(--blue300)',
    },
    {
        query: 'Why there is an increase in my ROI the last week?',
        icon: 'chart-bar',
        iconColor: 'var(--blue300)',
    },
    {
        query: 'What are my top performing ad groups by revenue?',
        icon: 'chart-bar',
        iconColor: 'var(--blue300)',
    },
    {
        query: 'Compare iOS vs Android performance metrics',
        icon: 'chart-bar',
        iconColor: 'var(--blue300)',
    },
];

const ChatEmptyState = ({ onSuggestionClick, input, handleInputChange, handleSubmit, isLoading, stop, onMicClick }) => {
    return (
        <div className={css.chatEmptyState}>
            <div className={css.greetingSection}>
                <SingularLogo className={css.greetingLogo} />
                <div className={css.greetingTitle}>Hello, how can I help?</div>
            </div>

            <div className={css.chatInputWrapper}>
                <ChatInput
                    input={input}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                    isLoading={isLoading}
                    stop={stop}
                    onMicClick={onMicClick}
                    containerClassName={css.chatInputInEmptyState}
                />
            </div>

            <div className={css.suggestionsGrid}>
                {SUGGESTIONS.map((suggestion, index) => (
                    <button
                        key={index}
                        onClick={() => onSuggestionClick(suggestion.query)}
                        className={css.suggestionCard}
                    >
                        <Icon
                            name={suggestion.icon}
                            type={IconTypes.TABLER}
                            size={IconSizes.SMALL}
                            className={css.suggestionIcon}
                            style={{ color: suggestion.iconColor }}
                        />
                        <div className={css.suggestionText}>{suggestion.query}</div>
                    </button>
                ))}
            </div>
        </div>
    );
};

ChatEmptyState.propTypes = {
    onSuggestionClick: PropTypes.func.isRequired,
    input: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    stop: PropTypes.func.isRequired,
    onMicClick: PropTypes.func,
};

export default ChatEmptyState;
